// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__t7HfW","header":"Modal_header__YGTY7","subtitle":"Modal_subtitle__F9cyb","footer":"Modal_footer__MAC9K"};